import * as React from "react";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { portalRoutes } from "@nju/routes";
import { BlockContent, GeneralErrorNotification, Loader } from "@nju/ui";
import { AreaDetails } from "../shared/AreaDetails";
import { areaRoamingPageMachine } from "./areaRoamingPage.machine";

export function AreaRoamingPage() {
  const router = useRouter();
  const params = portalRoutes.mojeKonto.uslugiDodatkowe.roaming.strefy
    .input(router.query)
    .unwrap();

  const [current] = useMachine(areaRoamingPageMachine);
  const { context, matches } = current;
  const { countries, zones } = context;

  const { exoCountries, stdCountries, euCountries } = React.useMemo(() => {
    return {
      exoCountries: countries?.filter((country) => {
        return country.zones.find((zone) => {
          return zone.name === "EXO";
        });
      }),
      stdCountries: countries?.filter((country) => {
        return country.zones.find((zone) => {
          return zone.name === "STD";
        });
      }),
      euCountries: countries?.filter((country) => {
        return country.zones.find((zone) => {
          return zone.name === "EU";
        });
      }),
    };
  }, [countries]);

  if (matches("loading")) {
    return (
      <BlockContent
        grid="narrow"
        spacing={{
          "@onlyMobile": "l",
          "@fromTablet": "xl",
        }}
        tone="secondary"
      >
        <div className="flex justify-center">
          <Loader size="50px" />
        </div>
      </BlockContent>
    );
  }

  if (matches("error") || !euCountries || !stdCountries || !exoCountries) {
    return (
      <GeneralErrorNotification
        callback={() => {
          return router.reload();
        }}
      />
    );
  }

  return (
    <AreaDetails
      category="ROAMING"
      countryFromUrl={params?.country}
      euCountries={euCountries}
      exoCountries={exoCountries}
      stdCountries={stdCountries}
      title="strefy roamingowe"
      userId={params?.userId}
      zone={params?.zone}
      zones={zones}
    />
  );
}
